import { fressnapfFontFamily } from '../fonts';

const fressnapfTypography = {
  h0: {
    fontFamily: fressnapfFontFamily,
    fontSize: '1.875rem',
    fontWeight: 700,
    lineHeight: '2.375rem,',
  },
  h1: {
    fontFamily: fressnapfFontFamily,
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: '2rem',
  },
  h2: {
    fontFamily: fressnapfFontFamily,
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: '1.75rem',
  },
  h3: {
    fontFamily: fressnapfFontFamily,
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: '1.5rem',
  },
  h4: {
    fontFamily: fressnapfFontFamily,
    fontSize: '0.875rem',
    fontWeight: 700,
    lineHeight: '1rem',
  },
  h5: {
    fontFamily: fressnapfFontFamily,
    fontSize: '0.75rem',
    fontWeight: 700,
    lineHeight: '1rem',
  },
  button: {
    fontFamily: fressnapfFontFamily,
    fontSize: '1.25rem',
    fontWeight: 800,
    lineHeight: '100%',
    textTransform: 'none',
  },
  body: {
    fontFamily: fressnapfFontFamily,
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: '1.25rem',
  },
  subText: {
    fontFamily: fressnapfFontFamily,
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.125rem',
  },
  legalText: {
    fontFamily: fressnapfFontFamily,
    fontSize: '0.75rem',
    fontWeight: 450,
    lineHeight: '1rem',
  },
};

export default fressnapfTypography;
